import { Box, Grid, Typography } from '@mui/material';
import useStyles from './styles';
import { AuthContext } from 'context/auth-context';
import { useContext } from 'react';
// Assets
import Item from 'assets/overviewSection/item.png';

export const PromoComponent = () => {
    const classes = useStyles();
    const { publicSettings } = useContext(AuthContext);

    const { SPEND_PROMOTION_CONTENT: spendPromoContent } = publicSettings;

    const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];

    const newDate = new Date();
    const month = months[newDate.getMonth()];
    const year = newDate.getFullYear();

    const updatedSpendPromoContent = {
        ...spendPromoContent.metadata,
        content: spendPromoContent.metadata.content.replace('{month}', month).replace('{year}', year),
        subtitle: spendPromoContent.metadata.subtitle.replace('{month}', month).replace('{year}', year)
    };

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            sx={{
                background: '#FFF',
                padding: '24px'
            }}>
            <Grid
                item
                xs={2}
                sx={{
                    padding: 0
                }}>
                <Box
                    sx={{
                        height: 1,
                        width: 1
                    }}
                    component="img"
                    alt="Bitcoin"
                    src={Item}
                />
            </Grid>
            <Grid
                item
                xs={8}
                sx={{
                    paddingLeft: '24px'
                }}>
                <Box>
                    <Typography variant="headerOfBanner">{updatedSpendPromoContent.title}</Typography>
                    <Typography variant="subHeaderOfBanner">{updatedSpendPromoContent.subtitle}</Typography>
                    <Typography variant="subtitle1">{updatedSpendPromoContent.content}</Typography>
                    <label className={classes.learnMoreText}>
                        <a
                            href={
                                spendPromoContent?.metadata?.link_terms_conditions ||
                                'https://www.paystand.com/defi-card-terms-of-service'
                            }
                            target="_blank"
                            rel="noopener noreferrer">
                            Terms & Conditions apply.
                        </a>
                    </label>
                </Box>
            </Grid>
            <Grid
                item
                xs={2}
                sx={{
                    paddingLeft: '24px'
                }}>
                <Box>
                    <label className={classes.learnMoreText}>
                        <a
                            href={
                                spendPromoContent?.metadata?.link_learn_more ||
                                'https://www.yahoo.com/now/paystand-delivers-first-business-expense-110000256.html'
                            }
                            target="_blank"
                            rel="noopener noreferrer">
                            Learn more
                        </a>
                    </label>
                </Box>
            </Grid>
        </Grid>
    );
};

export default PromoComponent;
